module.exports = __webpack_public_path__ + "static/jeffrey-van-harte-adaf33a020266167b4b8319c3429a93f.jpg";